import { useNavigate } from "react-router-dom";
import { ArrowLeft, Pencil, Store, ChevronRight, Pill } from "lucide-react";
import { Card } from "@/components/ui/card";

const TEAL = "#005C66";

export default function BuyMedicine() {
  const navigate = useNavigate();
  const options = [
    { key: "enter", testid: "buy-option-enter", Icon: Pencil, title: "Enter Medicines", desc: "Tell us what you need, then we'll find nearby pharmacies that have everything in stock.", to: "/order-medicines" },
    { key: "pharmacy", testid: "buy-option-pharmacy", Icon: Store, title: "Choose Pharmacy", desc: "Browse pharmacies near you and place your order directly with one.", to: "/find-pharmacies" },
  ];
  return (
    <div className="max-w-2xl mx-auto px-4 pb-24">
      <div className="flex items-center gap-2 py-4 sticky top-0 bg-background z-10">
        <button onClick={() => navigate(-1)} data-testid="buy-back" className="h-10 w-10 flex items-center justify-center rounded-full hover:bg-accent"><ArrowLeft className="h-5 w-5" /></button>
        <h1 className="text-2xl font-semibold">Buy Medicines</h1>
      </div>
      <div className="flex items-center gap-3 p-4 rounded-2xl mb-4" style={{ backgroundColor: "#F0F9FA" }}>
        <Pill className="h-6 w-6" style={{ color: TEAL }} />
        <p className="text-sm text-muted-foreground">How would you like to order?</p>
      </div>
      <div className="space-y-3">
        {options.map(({ key, testid, Icon, title, desc, to }) => (
          <Card key={key} data-testid={testid} onClick={() => navigate(to)} className="rounded-3xl p-5 cursor-pointer hover:shadow-md transition-shadow">
            <div className="flex items-center gap-4">
              <div className="h-12 w-12 rounded-2xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "#E0F2F1" }}>
                <Icon className="h-6 w-6" style={{ color: TEAL }} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold">{title}</p>
                <p className="text-sm text-muted-foreground">{desc}</p>
              </div>
              <ChevronRight className="h-5 w-5 text-muted-foreground flex-shrink-0" />
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
